import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import {
    FETCH_CARD_RELEASE_TRACKING,
    FETCH_CARD_RELEASE_TRACKINGS,
    REMOVE_CARD_RELEASE_TRACKINGS
} from './types';

const notifyError = (error, fallback) => {
    NotificationManager.error(error.response?.data?.msg || fallback);
};

export const fetchCardReleaseTrackings = filter => dispatch => api
    .get('/card-release-trackings', { params: filter })
    .then(response => {
        dispatch({ type: FETCH_CARD_RELEASE_TRACKINGS, payload: response.data.data });
        return response.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tải danh sách phát hành thẻ.');
        return Promise.reject(error);
    });

export const fetchCardReleaseTracking = id => dispatch => api
    .get(`/card-release-trackings/${id}`)
    .then(response => {
        dispatch({ type: FETCH_CARD_RELEASE_TRACKING, payload: response.data.data });
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tải chi tiết phát hành thẻ.');
        return Promise.reject(error);
    });

export const createCardReleaseTracking = data => () => api
    .post('/card-release-trackings', data)
    .then(response => {
        NotificationManager.success(response.data.msg);
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể thêm phát hành thẻ.');
        return Promise.reject(error);
    });

export const updateCardReleaseTracking = (id, data) => () => api
    .put(`/card-release-trackings/${id}`, data)
    .then(response => {
        NotificationManager.success(response.data.msg);
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể cập nhật phát hành thẻ.');
        return Promise.reject(error);
    });

export const removeCardReleaseTrackings = ids => dispatch => api
    .delete('/card-release-trackings', { data: { ids } })
    .then(response => {
        dispatch({ type: REMOVE_CARD_RELEASE_TRACKINGS, payload: ids });
        NotificationManager.success(response.data.msg);
        return response.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể xóa phát hành thẻ.');
        return Promise.reject(error);
    });
